import React from 'react'
import Link from 'gatsby-link'
import '../../sass/components/_productSelector.scss';

class ProductSelector extends React.Component {

  constructor(props) {
    super(props);

    this.handleGenderChange = this.handleGenderChange.bind(this);
    this.handleSizeChange = this.handleSizeChange.bind(this);
    this.handleAmountChange = this.handleAmountChange.bind(this);


    const tmpSelectedGender = (Object.keys(this.props.stock).length > 1) ? false : "u";
    const tmpSelectedSize = (tmpSelectedGender && this.props.stock["u"] != undefined && this.props.stock["u"].length == 1) ? "0" : false;
    
    
    
    
    
    this.state = {
      selectedGender: tmpSelectedGender,
      selectedSize: tmpSelectedSize,
      selectedAmount: 0,
      errorMessage: false
    }

  }

  handleGenderChange(element){
    this.setState({
      selectedGender: element.target.value,
      errorMessage: false,
      selectedAmount: 0
    })
  }
  handleSizeChange(element){
    this.setState({
      selectedSize: element.target.value,
      errorMessage: false,
      selectedAmount: 0
    })
  }
  handleAmountChange(element){
    if (this.props.stock[this.state.selectedGender][this.state.selectedSize].count == 0){
      this.setState({
        selectedAmount: 0,
        errorMessage: "out of stock"
      })
    } else if (element.target.value >= this.props.stock[this.state.selectedGender][this.state.selectedSize].count) {
      this.setState({
        selectedAmount: this.props.stock[this.state.selectedGender][this.state.selectedSize].count,
        errorMessage: "only "+this.props.stock[this.state.selectedGender][this.state.selectedSize].count+" items left in stock"
      })
    } else if (element.target.value < 0) {
      this.setState({
        selectedAmount: 0,
        errorMessage: false
      })
    } else {
      this.setState({
        selectedAmount: element.target.value,
        errorMessage: false
      })
    }
  }

  render(){
    let orderId = false;
    let orderName = false;

    const genders = (Object.keys(this.props.stock).length > 1);//multiple genders?
    const sizes = genders ||  (!genders && this.props.stock["u"] != undefined && this.props.stock["u"].length > 1);//multiple sizes?

    if (this.state.selectedGender && this.state.selectedSize && this.state.selectedAmount>0) {
      orderId = "product_"+this.props.stock[this.state.selectedGender][this.state.selectedSize].id;
      
      orderName = this.props.product.title
      if (genders) {
        orderName += " " + this.state.selectedGender;
      }
      if (sizes) {
        orderName += " " + this.props.stock[this.state.selectedGender][this.state.selectedSize].size;
      }
    }

    return (
      <div className={"productSelector" + (this.props.sizes ? " loaded" : " loading")}>
        {genders && 
          <span className="gender">gender:
            <select disabled={this.props.sizes == false} defaultValue="gender" onChange={(e)=>this.handleGenderChange(e)}>
              <option value="gender" disabled >gender</option>
              {this.props.stock && Object.keys(this.props.stock).map((x, index)=>
                <option key={index} value={x}>{x}</option>
              )}
            </select>
          </span>
        }
        {sizes && 
          <span className="size">size: 
            <select disabled={this.props.sizes == false || this.state.selectedGender == false} defaultValue="size" onChange={(e)=>this.handleSizeChange(e)}>
              <option value="size" disabled >size</option>
              {(this.props.stock && this.state.selectedGender) && this.props.stock[this.state.selectedGender].map((elem, index) =>
                <option key={index} value={index} disabled={elem.count <= 0} >{elem.count <= 0 ? elem.size+" out of stock" : elem.size}</option>
              )}
            </select>
          </span>
        }
        <br/><span className="amount">
          amount: 
          <input
            disabled={!this.state.selectedGender || !this.state.selectedSize}
            className="amount"
            type="number"
            value={this.state.selectedAmount}
            onChange={(e)=>this.handleAmountChange(e)}
          />
        </span>
        <button
          className="snipcart-add-item"
          data-item-id={orderId}
          data-item-name={orderName}
          data-item-price={parseFloat(Math.round(this.props.product.price * 100) / 100).toFixed(2)}
          data-item-url={`https://broomwagongirona.netlify.com/products/prices/${orderId}/`}
          disabled={!orderId}
          data-item-quantity={orderId && this.state.selectedAmount}
          data-item-max-quantity={orderId && this.props.stock[this.state.selectedGender][this.state.selectedSize].count}
        >
          Add to cart
        </button>
        {this.state.errorMessage && <span className="error">{this.state.errorMessage}</span>}
      </div>
    )
  }
}

export default ProductSelector



// WEBPACK FOOTER //
// ./src/components/ProductSelector.js